"use client";

import dynamic from "next/dynamic";

// Code-split below-fold homepage components.
// SSR preserved for crawlers; client JS loads asynchronously
// to reduce main-thread blocking on initial page load.

export const LazyProductTour = dynamic(
  () => import("@/components/landing/ProductTour"),
  { ssr: true, loading: () => <div className="min-h-[200px]" /> }
);

export const LazyPricingSection = dynamic(
  () => import("@/components/landing/PricingSection"),
  { ssr: true, loading: () => <div className="min-h-[300px]" /> }
);

export const LazyTestimonials = dynamic(
  () => import("@/components/landing/Testimonials"),
  { ssr: true, loading: () => <div className="min-h-[100px]" /> }
);
